import React from 'react';
import { Box, Button, Container, Typography } from '@material-ui/core';

const BannerAnnouncementStrip = ({ sectionConfig = {}, layoutContext = {}, globalConfig = {} }) => {
  const { applyHoverEffect, removeHoverEffect, getIcon, handleSignUpClick, isExternal } = layoutContext;

  if (!sectionConfig || !layoutContext?.isExternal) {
    return null;
  }

  return (
    <Box style={sectionConfig.styles || {}}>
      <Container maxWidth={sectionConfig.container?.maxWidth} style={sectionConfig.containerStyles || {}}>
        <Box style={sectionConfig.contentStyles || {}}>
          <Typography
            variant={sectionConfig.typography?.variant || 'h6'}
            style={sectionConfig.messageStyles || {}}
          >
            {sectionConfig.message || globalConfig?.joinMessage}
          </Typography>

          {isExternal && (
            <Button
              variant={sectionConfig.button?.variant || 'contained'}
              startIcon={getIcon?.(sectionConfig.button?.icon || 'launch')}
              onClick={handleSignUpClick}
              style={sectionConfig.button?.styles || {}}
              onMouseEnter={(e) => applyHoverEffect?.(e, sectionConfig.button?.hoverStyles || {})}
              onMouseLeave={(e) => removeHoverEffect?.(e, sectionConfig.button?.styles || {})}
            >
              {sectionConfig.button?.text || 'Join Now'}
            </Button>
          )}
        </Box>
      </Container>
    </Box>
  );
};

export default BannerAnnouncementStrip;
